import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';
import dayjs from 'dayjs';

import navigationPaths from 'engine/navigationPaths';

import DashboardLayout from 'components/dashboardLayout/dashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import { Box, Button } from 'components/ui';
import { GridView, Header, Sidebar, Table } from './components';

import * as Styled from './CostList.styles';

export const CostList = () => {
  const navigate = useNavigate();

  const [viewType, setViewType] = useState('grid');
  const [filters, setFilters] = useState({
    fromDate: dayjs().utc(true).subtract(30, 'day').format('YYYY-MM-DD'),
    toDate: dayjs().utc(true).format('YYYY-MM-DD'),
  });

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Styled.Wrapper>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button onClick={() => navigate(navigationPaths().CostInvoicesForm)}>Dodaj koszt</Button>
          </Grid>
          <Grid item xs={12} xxl={8}>
            <Box>
              <Header filters={filters} changeFilters={setFilters} view={viewType} changeView={setViewType} />

              <Styled.List>
                {viewType === 'table' ? <Table filters={filters} /> : <GridView filters={filters} />}
              </Styled.List>
            </Box>
          </Grid>
          <Grid item xs={12} xxl={4}>
            <Sidebar />
          </Grid>
        </Grid>
      </Styled.Wrapper>
    </DashboardLayout>
  );
};
